module["exports"] = [
  "Polska"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pl/address/default_country.js
// module id = 878
// module chunks = 0